// ─────────────────────────────────────────────
//  BreakStatusRow — 4-channel break strip (breakfast/lunch/dinner/bathroom)
//  Extracted from BoardPage.js (02-01). Presentational only — no Firestore.
//  Cell colors come from the breakStatusRow() domain helper (domain/breaks.js);
//  never hard-coded here. The atcFlash animation is suppressed under
//  prefers-reduced-motion per the UI-SPEC Accessibility Contract.
// ─────────────────────────────────────────────
import React from "react";
import tokens from "../theme/tokens";

const { space, radius } = tokens;

// Read the user's reduced-motion preference once at render. matchMedia is not
// available in some non-browser/test environments, so guard for it.
function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export default function BreakStatusRow({ row = [] }) {
  const reduceMotion = prefersReducedMotion();

  return (
    <div style={styles.row} aria-label="Break status">
      {row.map((cell) => {
        // Flash a channel while it's being covered (in_progress) as well as
        // when it's flagged (requested) so "which break is covered" is obvious.
        const shouldFlash = cell.flashing || cell.state === "in_progress";
        return (
          <div
            key={cell.channel}
            title={`${cell.channel}: ${cell.label}`}
            style={{
              ...styles.cell,
              background: cell.color,
              opacity: cell.state === "none" ? 0.25 : 1,
              ...(shouldFlash && !reduceMotion
                ? { animation: "atcFlash 1s steps(1) infinite" }
                : {}),
            }}
          >
            {cell.channel.slice(0, 4)}
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  row: {
    display: "flex",
    gap: space.xs,
    marginTop: space.sm,
  },
  cell: {
    flex: 1,
    fontSize: 9,
    textTransform: "capitalize",
    textAlign: "center",
    padding: "3px 0",
    borderRadius: radius.sm,
    color: "#fff",
  },
};
